import workspace from "./workspace";
import { getFilteredWorkspaceData } from "@/utils/workspaceOrgFilter";
import { useStore } from "@/store";


export const getUpdateQueues = async () => {
  const userOrg = useStore.userOrg();
  const params =  { org_name: userOrg };
  try {
    return getFilteredWorkspaceData('/updatequeue/', 'organization', { params });
  } catch (error) {
    console.error("Error fetching updatequeue:", error);
    throw error;
  }
};


export const getUpdateQueueById = async (id) => {
  try {
    const response = await workspace.get(`/updatequeue/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching updatequeue with ID ${id}:`, error);
    throw error;
  }
};

